enum PatientStatusFilter {
    A = 1,
    H = 2,
}

export default PatientStatusFilter;
